import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Contactus.css";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import phoneIcon from "../Assets/phone-call.png";
import mailIcon from "../Assets/mail.png";
import locationIcon from "../Assets/location.png";

const ContactUs = () => {
  const formRef = useRef(null);
  const mapRef = useRef(null);
  const exploreRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const lastSubmitRef = useRef(0); //rate limit

  useEffect(() => {
    const sections = [formRef.current, mapRef.current, exploreRef.current];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.15 },
    );

    sections.forEach((sec) => sec && observer.observe(sec));
    return () => observer.disconnect();
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    // Honeypot spam protection
    if (e.target.website.value) return;

    // Rate limiting (10 seconds)
    const now = Date.now();
    if (now - lastSubmitRef.current < 10000) {
      toast.warn("Please wait before submitting again.");
      return;
    }
    lastSubmitRef.current = now;

    // Validation
    const form = e.target;
    const name = form.name.value.trim();
    const email = form.email.value.trim();
    const message = form.message.value.trim();

    if (!name || !email || !message) {
      toast.error("Please fill all required fields.");
      return;
    }

    setLoading(true);

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAIL_SERVICE_ID,
        process.env.REACT_APP_EMAIL_TEMPLATE_ID,
        form,
        process.env.REACT_APP_EMAIL_PUBLIC_KEY,
      )
      .then(
        () => {
          toast.success("Message sent successfully!");
          form.reset();
        },
        (error) => {
          console.error("EmailJS Error:", error);
          toast.error("❌ Failed to send message. Please try again.");
        },
      )
      .finally(() => setLoading(false));
  };

  return (
    <div className="contact-us-page">
      {/* FORM SECTION */}
      <section className="form-section fade-section" ref={formRef}>
        <div className="form-container">
          <p className="form-small-heading">Contact Us</p>
          <h1 className="form-title">Hi there! Let’s talk.</h1>
          <p className="form-description">
            Leave your contact information through the form, and we will get in
            touch with you as soon as possible!
          </p>

          <form className="contact-form" onSubmit={sendEmail}>
            {/* Honeypot field (hidden spam trap) */}
            <input
              type="text"
              name="website"
              style={{ display: "none" }}
              tabIndex="-1"
              autoComplete="off"
            />

            {/* Hidden time field */}
            <input
              type="hidden"
              name="submitted_at"
              value={new Date().toLocaleString("en-IN", {
                dateStyle: "medium",
                timeStyle: "short",
              })}
            />

            <div className="form-row">
              <div className="form-group">
                <label>Full Name *</label>
                <input type="text" name="name" required />
              </div>
              <div className="form-group">
                <label>Email Address *</label>
                <input type="email" name="email" required />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Phone *</label>
                <input type="tel" name="phone" required />
              </div>
              <div className="form-group">
                <label>Company Name *</label>
                <input type="text" name="company" required />
              </div>
            </div>

            <div className="form-group full-width">
              <label>Please, tell us a bit more about your needs.</label>
              <textarea name="message" required></textarea>
            </div>

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Inquiry"}
            </button>
          </form>
        </div>
      </section>

      {/* MAP SECTION */}
      <section className="map-section fade-section" ref={mapRef}>
        <div className="contact-info">
          <h2>Contact Information</h2>
          <p>
            <img src={phoneIcon} alt="Phone Icon" className="icon" />
            +91-9978611325
          </p>
          <p>
            <img src={mailIcon} alt="Email Icon" className="icon" />
            sales@onenesswebs.com
          </p>
          <p>
            <img src={locationIcon} alt="Location Icon" className="icon" />
            Bilimora - 396321, Gujarat, India.
          </p>
        </div>

        <div className="map-container">
          <iframe
            title="Oneness Websolution Map"
            src="https://www.google.com/maps?q=Bilimora,+Gujarat,+India+396321&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>

      {/* EXPLORE SECTION */}
      <section className="explore-section fade-section" ref={exploreRef}>
        <div className="explore-card">
          <h2 className="explore-title">Checkout our recent projects</h2>
          <p className="explore-description">
            From mobile apps to web apps, we make business come alive across the
            globe for multiple domains
          </p>
          <Link to="/portfolio" className="explore-button">
            Explore our projects
          </Link>
        </div>
      </section>

      <ToastContainer position="top-center" autoClose={4000} pauseOnHover />
    </div>
  );
};

export default ContactUs;
